/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SuppliersListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: SuppliersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';

import myGlobals = require('../globals');
import { SuppliersData, SuppliersService } from './Suppliers.service';
import { SuppliersSearchComponent }  from './SuppliersSearch.component';

@Component({
	selector: 'my-Suppliers',
	template: require('./SuppliersList.component.html'),
	providers: [SuppliersService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class SuppliersListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	SuppliersList: SuppliersData[];
	newSuppliers: SuppliersData;
	selectedSuppliers: SuppliersData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(SuppliersSearchComponent) filterComponent: SuppliersSearchComponent;

	sortExpression: string = "SupplierID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private SuppliersService: SuppliersService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newSuppliers = new SuppliersData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		//this.SuppliersService.getAll().subscribe(record => this.SuppliersList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getSuppliersByPaging();

		/*
		this.SuppliersList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getSuppliers() {
		this.SuppliersService.getAll()
			.subscribe(data => this.SuppliersList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on SuppliersSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getSuppliersByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getSuppliersByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getSuppliersByPaging();
	}
	
	// Get records by paging
	getSuppliersByPaging() {
		this.SuppliersService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.SuppliersList=data.SuppliersList;
				this.rowsCount=data.RowsCount;
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}

	// Adds new record
	addSuppliers() {
		this.SuppliersService.addSuppliersData(this.newSuppliers).subscribe(record => console.log(record));
		this.getSuppliers();
	}

	// Updates existing record
	updateSuppliers() {
		this.SuppliersService.updateSuppliersData(this.selectedSuppliers).subscribe(record => console.log(record));
		this.getSuppliers();
	}

	// Deletes record with specified id
	deleteSuppliers(id: string) {
		if (window.confirm('Are you sure you want to delete this Suppliers?') == true)
		{
			this.SuppliersService.deleteSuppliers(id)
			.subscribe(data => this.getSuppliers(),
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('Suppliers record deleted successfully...', 'Delete Suppliers');
					console.log('Suppliers record deleted successfully...'); 
				}
			);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getSuppliersByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getSuppliersByPaging();
		}
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getSuppliersByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getSuppliersByPaging();
	}

	// On Edit - Go to Edit page
	onSelect(item: SuppliersData) {
		this.router.navigate(['/Suppliers', item.SupplierID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: SuppliersData) {
		this.router.navigate(['/Suppliers/Details', item.SupplierID]);
	}

	// Set record as selected
	SelectSuppliers(item: SuppliersData) {
		this.selectedSuppliers = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Suppliers/SuppliersList.component.ts